import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "filter-age-range" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "filter-age-range__divider" }, "-", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NSelect = _resolveComponent("NSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NSelect, {
      "model-value": _ctx.ageGte,
      items: _ctx.minItems,
      plain: _ctx.plain,
      disabled: _ctx.disabled,
      selectonly: "",
      placeholder: "1",
      "clear-icon": "",
      "onUpdate:modelValue": _ctx.changeHandlerGte
    }, null, 8, ["model-value", "items", "plain", "disabled", "onUpdate:modelValue"]),
    _hoisted_2,
    _createVNode(_component_NSelect, {
      "model-value": _ctx.ageLte,
      items: _ctx.maxItems,
      plain: _ctx.plain,
      disabled: _ctx.disabled,
      selectonly: "",
      placeholder: String(_ctx.maxValue),
      "clear-icon": "",
      "onUpdate:modelValue": _ctx.changeHandlerLte
    }, null, 8, ["model-value", "items", "plain", "disabled", "placeholder", "onUpdate:modelValue"])
  ]))
}